// extracted by mini-css-extract-plugin
export default {"logout_panel":"LogoutPanel_logout_panel__LDN17","logout_btn":"LogoutPanel_logout_btn__Ay4GO"};